import { gql } from '@apollo/client';
import { BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS } from './portfolioReportLookupFields';

export const REFRESH_PORTFOLIO_REPORT_FOR_LOOKUP = gql`
  mutation refreshPortfolioReportForLookup(
    $input: RefreshPortfolioReportInput!
  ) {
    refreshPortfolioReport(input: $input) {
      portfolioReport {
        ${BULK_REBALANCE_PORTFOLIO_REPORT_FIELDS}
      }
    }
  }
`;
